import { render, staticRenderFns } from "./downloadProject.vue?vue&type=template&id=44e7e646&scoped=true&lang=pug&"
import script from "./downloadProject.vue?vue&type=script&lang=js&"
export * from "./downloadProject.vue?vue&type=script&lang=js&"
import style0 from "./downloadProject.vue?vue&type=style&index=0&id=44e7e646&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e7e646",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e7e646')) {
      api.createRecord('44e7e646', component.options)
    } else {
      api.reload('44e7e646', component.options)
    }
    module.hot.accept("./downloadProject.vue?vue&type=template&id=44e7e646&scoped=true&lang=pug&", function () {
      api.rerender('44e7e646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/downloadProject.vue"
export default component.exports